
import ChatInputV2 from 'components/chat-input-v2'
import CommandsShortcuts from 'components/chat-input-v2/commands-menu/commands-shortcuts.vue' // TODO: move commands to components/commands
import $chats from 'stores/chats'
import $profile from 'stores/profile'
import {computed} from 'vue'

export default {
  components: {ChatInputV2, CommandsShortcuts},
  provide() {
    return {
      di_chat_mode: computed({
        get: () => this.mode,
        set: mode => this.mode = mode
      })
    }
  },
  data() {
    return {
      input_text: '',
      caps: undefined,
      mode: 'deep',
      creating: false,
      expanded: true
    }
  },
  async beforeMount() {
    if (!this.$route.query.chat_query) return

    const params = JSON.parse(this.$route.query.chat_query)
    const chat = await $chats.newChat(params, $profile.chat_type)
    this.$global.goToChat(chat.id)
  },

  mounted() {
    if (this.$responsive.mobile) return
    this.$refs.input.focus()
  },

  methods: {
    async waitForAnimation() {
      if (this.$responsive.mobile) return
      await this.$nextTick()
      const page = this.$refs.page
      const input = this.$refs.input?.$el

      const fadeout = page.getAnimations({subtree: true}).map(animation => animation.finished)
      // Removed shortcut menus cancel their animations; cancellation completes the wait.
      await Promise.allSettled(fadeout)
            
      const distance = Math.max(0, page.getBoundingClientRect().bottom - input.getBoundingClientRect().bottom)
      input.style.setProperty('--slide-distance', `${distance}px`)
      const slide = input.getAnimations().map(animation => animation.finished)
      await Promise.allSettled(slide)

      input.style.removeProperty('--slide-distance')
      input.style.position = 'absolute'
      input.style.bottom = '0'
      input.style.left = '0'
      input.style.right = '0'
      this.expanded = false
      await this.$nextTick()
      const transitions = input.getAnimations({subtree: true})
        .filter(animation => animation.transitionProperty?.startsWith('padding'))
        .map(animation => animation.finished)
      await Promise.allSettled(transitions)
    },
    async onChat(query) {
      this.creating = true

      const [chat] = await Promise.all([
        $chats.newChat({...query, mode: this.mode}, $profile.chat_type),
        this.waitForAnimation()
      ])
      await this.$global.goToChat(chat.id)
    },
  }
}
